
export const VALIDATE_APPOINTMENT = 'validate_appointment'

export const APPOINTMENT_REMINDER_CALL = 'appointment_reminder_call'

export const CHECK_ID = 'check_id'

export const COMPLETE_ANAMNESIS = 'complete_anamnesis'

export const MAKE_CUSTOMER_SCAN_APPOINTMENT = 'make_customer_scan_appointment'

export const MAKE_CUSTOMER_IPR_APPOINTMENT = 'make_customer_ipr_appointment'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/check-in/task-name.js